
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Création de sites Web : les experts d’ALEO vous accompagnent dans votre projet",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "La création d’un site Internet peut sembler un véritable défi. L’agence de communication ALEO et ses experts du digital vous accompagnent dans cette formidable aventure et dans l’atteinte de vos objectifs de croissance.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Création de sites Web : les experts d’ALEO vous accompagnent dans votre projet",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "La création d’un site Internet peut sembler un véritable défi. L’agence de communication ALEO et ses experts du digital vous accompagnent dans cette formidable aventure et dans l’atteinte de vos objectifs de croissance.",
        },
      ],
    };
  },
};
